<template>
  <div class="dtablerow">

    <!-- Left Panel -->
    <aside id="left-panel" class="left-panel">
      <LeftMenu/>
    </aside><!-- /#left-panel -->
    <!-- Left Panel -->

    <!-- Right Panel -->
    <div id="right-panel" class="right-panel">
      <!-- Header-->
      <header id="header" class="header">
        <div class="header-menu">
          <div class="col-sm-7">
            <MenuToggle/>
            <div class="header-left">
              <HeaderSearch/>
              <HeaderCompanySelector/>
              <HeaderNotification/>
              <HeaderMessages/>
            </div>
          </div>
          <div class="col-sm-5">
            <User/>
            <LngChooser/>
          </div>
        </div>
      </header><!-- /header -->
      <!-- Header-->
      <Breadcrumbs :breadcrumbstitle="breadcrumbstitle" :breadcrumbsData="breadcrumbsData"/>
      <div class="content mt-3">
        <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :msgPre="AlertInPage.msgPre" :msgPost="AlertInPage.msgPost" :delay="AlertInPage.delay"/>

        <div class="animated fadeIn" v-if="this.hasRole">
          <!-- content place -->


          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('InvoiceInboundNAVRefresh.title')}}</strong>
                <div class="float-right">
                  <!--<router-link :to="{ path: '/Vats'}" class="btn btn-primary btn-sm"><i class="fa fa-link"></i> {{$t('Vats.title')}}</router-link>-->
                  &nbsp;
                  <!--<span class="btn btn-primary btn-sm" v-on:click="emptyForNew()"><i class="fa fa-link"></i> {{$t('Vat.new')}}</span>-->
                  <span v-if="state && state.user && state.user.role && state.user.role==='ADMIN'">
                    <router-link :to="{ path: '/sbinvoiceinbounds'}" class="btn btn-link btn-sm"><i class="fa fa-link"></i> {{$t('InvoiceInboundNAVRefresh.invoiceinbounds')}}</router-link>
                  </span>
                  <span v-if="state && state.user && state.user.role && state.user.role!=='ADMIN'">
                    <router-link :to="{ path: '/invoiceinboundsaccountant'}" class="btn btn-link btn-sm"><i class="fa fa-link"></i> {{$t('InvoiceInboundNAVRefresh.invoiceinbounds')}}</router-link>
                  </span>
                </div>
              </div>
              <div class="card-body card-block">

                <div v-if="intNavFillError===1" class="alert alert-danger">{{ $t('InvoiceInboundNAVRefresh.attentiontextNavError') }}
                  <router-link to="/settings" tag="span" class="cursor nav-item"><i class="fa fa-gears"></i> {{ $t('LeftMenu.settings') }}</router-link>
                </div>

                <!--<AlertInPage />-->
                <!--<AlertInPage type="success" msg="msg" delay="2000"/>-->
                <form action="" method="post" enctype="multipart/form-data" class="form-horizontal">

                  <div class="row form-group">
                    <div class="col col-12">
                      <!--Nav 35 days max-->
                      <!--<p>{{ $t('InvoiceInboundNAVRefresh.info') }}</p>-->
                      <!--<div class="alert alert-warning">{{ $t('InvoiceInboundNAVRefresh.attentiontext') }}</div>-->
                      <!--<div class="alert alert-warning">{{ $t('InvoiceInboundNAVRefresh.attentiontext2') }}</div>-->
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col col-md-3"><label for="dt_from" class=" form-control-label">{{ $t('InvoiceInboundNAVRefresh.dt_from') }} ({{ $t('validator.required')
                      }})</label>
                    </div>
                    <div class="col-12 col-md-9">
                      <InputText type="DatetimepickerBp"
                                 id="dt_from" name="data.dt_from" v-model="data.dt_from" v-validate="{date_format:'yyyy-MM-dd','isodate':true, required:true}" hasToKeyboard="auto" value=""
                                 :title="$t('InvoiceInboundNAVRefresh.dt_from')"
                                 placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.dt_from')"
                      />
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col col-md-3"><label for="dt_to" class=" form-control-label">{{ $t('InvoiceInboundNAVRefresh.dt_to') }} ({{ $t('validator.required')
                      }})</label>
                    </div>
                    <div class="col-12 col-md-9">
                      <InputText type="DatetimepickerBp"
                                 id="dt_to" name="data.dt_to" v-model="data.dt_to" v-validate="{date_format:'yyyy-MM-dd','isodate':true, required:true}" hasToKeyboard="auto" value=""
                                 :title="$t('InvoiceInboundNAVRefresh.dt_to')"
                                 placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.dt_to')"
                      />
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>


                  <!--<hr>-->
                  <!--<div class="row form-group">-->
                  <!--<div class="col col-md-3"><label for="deleted" class=" form-control-label">{{ $t('global.deleted') }}</label></div>-->
                  <!--<div class="col-12 col-md-9">-->
                  <!--<select class="form-control" id="deleted" v-model="data.deleted" name="data.deleted">-->
                  <!--<option value="0">{{$t('global.no')}} </option>-->
                  <!--<option value="1">{{$t('global.yes')}}</option>-->
                  <!--</select>-->
                  <!--</div>-->
                  <!--</div>-->

                </form>
              </div>

              <div class="card-footer">
                <button v-if="intNavFillError!==1" type="button" class="btn btn-primary btn-sm" v-on:click="navRefreshPeriod"
                        :disabled="inprogress"
                >
                  <i class="fa fa-download"></i> {{$t('InvoiceInboundNAVRefresh.invoicedownload')}}
                </button>


                <br>
                <!--<button type="button" class="btn btn-primary btn-sm" v-on:click="initCounter">-->
                <!--<i class="fa fa-download"></i> {{$t('global.init')}}-->
                <!--</button>-->
                <div v-if="redirectCounter>0">
                  <p>{{ $t('InvoiceInboundNAVRefresh.redirect_text') }}</p>
                  <button type="button" class="btn btn-primary btn-sm" v-on:click="cancelCounter">
                    <i class="fa fa-link"></i> {{$t('InvoiceInboundNAVRefresh.cancel')}} &nbsp;<span>({{redirectCounter}})</span>
                  </button>
                </div>

                <!--<button type="submit" class="btn btn-primary btn-sm" v-on:click="navRefreshPeriodMonth"-->
                <!--:disabled="inprogress"-->
                <!--&gt;-->
                <!--<i class="fa fa-dot-circle-o"></i> {{$t('global.submit')}}-->
                <!--</button>-->
                <!--<button type="reset" class="btn btn-danger btn-sm">-->
                <!--<i class="fa fa-ban"></i> Reset-->
                <!--</button>-->
              </div>
              <div class="card-body card-block fColumn">
                <p>{{ $t('InvoiceInboundNAVRefresh.resultinfo') }}</p>

                <div class="text-right mb-2">
                  <button type="button" class="btn btn-success btn-sm" v-on:click="getElements"
                          :disabled="inprogress"
                  >
                    <i class="fa fa-refresh"></i> {{$t('InvoiceInboundNAVRefresh.tablerefresh')}}
                  </button>
                </div>

                <div class="fContent">
                  <TableDatatableJs :head="head" :data="dataDt" :options="{isTextSearch:false}" />

                </div>
              </div>

            </div>

          </div>


        </div><!-- .animated -->

        <div class="animated fadeIn" v-if="!this.hasRole">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemcheckstitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemchecks')}}</div>
            </div>
          </div>
        </div><!-- .animated -->
        <div class="animated fadeIn" v-if="this.hasRole&&!this.hasCompany">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemnocompanytitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemnocompany')}}</div>
            </div>
          </div>
        </div><!-- .animated -->

      </div><!-- .content -->
    </div><!-- /#right-panel -->
    <!-- Right Panel -->
  </div>

</template>

<script>

  // @ is an alias to /src
  import LeftMenu from '@/components/LeftMenu.vue';
  import HeaderSearch from '@/components/HeaderSearch.vue';
  import HeaderCompanySelector from '@/components/HeaderCompanySelector.vue';
  import HeaderNotification from '@/components/HeaderNotification.vue';
  import HeaderMessages from '@/components/HeaderMessages.vue';
  import User from '@/components/User.vue';
  import LngChooser from '@/components/LngChooser.vue';
  import Breadcrumbs from '@/components/Breadcrumbs.vue';
  import AlertInPage from '@/components/AlertInPage.vue';
  import Api from '@/api/Api';
  import Helper from '@/helper/Helper';
  import HelperRole from '@/helper/HelperRole';
  import MenuToggle from '@/components/MenuToggle.vue';
  import InputText from '@/components/InputText.vue';
  import moment from "moment";
  import TableDatatableJs from '@/components/TableDatatableJs.vue';


  //  id_store 	wsid 	text
  export default {
    name: 'InvoiceInboundNAVRefresh',
    data() {
      const modul = this;
      return {
        Helper: Helper
        , data: {
          "dt_from": "",
          "dt_to": "",
        }
        , dataBase: { // need for change without save
          "dt_from": "",
          "dt_to": "",
        }
        , AlertInPage: {
          type: "", // primary secondary success danger warning info light dark
          msg: "",
          msgPre: "",
          msgPost: "",
          delay: 5000,
        }
        , breadcrumbstitle: 'InvoiceInboundNAVRefresh.title'
        , breadcrumbsData: [
//          {
//            'title': "InvoiceInboundNAVRefresh.title",
//            'url': "InvoiceInboundNAVRefresh",
//          },
          {
            'title': "InvoiceInboundNAVRefresh.title",
          }
        ]
        , HelperRole: HelperRole
        , hasRole: false
        , hasCompany: false
        , state: {}
        , stateHash: ""
        , inprogress: false
        , myTimerFnVar: function () {
        }
        , redirectCounter: 0
        , redirectCounterIntervalObject: 0
        , redirectOff: false
        , intNavFillError: 0 // 1 error, -1 all ok , 0 unidentified
        , settings: {}
        ,
        dataDt: [],
        head: [
//          {
//            title: "Vats.dttitle",
//            data: "id",
//            link: true,
//            linkurl: "Vat",
//            linkclass: "text-nowrap",
//            linkiconclass: "menu-icon fa fa-edit btn-link",
//            linktext: "", // Vats.linktext
//          }
//          ,
//          {
//            key: "taskid",
//            title: "Task.jobid",
//            searchField: true
//          },
          {
            key: "tasktimestamp",
            title: "Task.tasktimestamp",
            render: this.renderTs,
            searchField: true
            ,sortDirection: "desc"
          },
          {
            key: "name",
            title: "Task.name",
            render: this.renderName,
            searchField: true
          }
          , {
            key: "taskstatus",
            title: "Task.taskstatus",
            render: this.renderName,
            searchField: true
          }
          , {
            key: "taskresult",
            title: "Task.taskresult",
            searchField: true
            , classtd: "text-center"
          }
          , {
            key: "taskparams",
            title: "Task.params",
            render: function (data, type, dataRow, meta) {
              let dataRet = "";
              try {
                const dataObject = JSON.parse(data);
                if (dataObject.dateFrom) {
                  dataRet += dataObject.dateFrom + " - ";
                }
                if (dataObject.dateTo) {
                  dataRet += dataObject.dateTo + "";
                }
              } catch (e) {
                dataRet = data;
              }
              return dataRet;
            },
            searchField: true
          }


          , {
            key: "id",
            title: "global.delete",
            data: "user2company_id_user",


            linkclass: "text-nowrap btn btn-info",
            linktext: "global.delete",
            linkiconclass: "menu-iconfafa-users",
//            displayFn: function (data, type, row, meta) { // data, type, row, meta
//              let hasWf = false;
//              if (row.wf_status && row.wf_status === "ACCEPTED") {
//                hasWf = true;
//              }
//              let hasSum = false;
//              if (HelperRole.hasRights(modul.state, [15], false)) {
//                if (row.sumnum && !isNaN(Number(row.sumnum)) && Number(row.sumnum) > 0 && row.navdata) { //
//                  hasSum = true;
//                }
//              } else if (!HelperRole.hasRights(modul.state, [15], false)) {
//                if (row.sumnum && !isNaN(Number(row.sumnum)) && Number(row.sumnum) > 0) { //
//                  hasSum = true;
//                }
//              }
//              if (hasWf && hasSum) {
//                return true;
//              } else {
//                return false;
//              }
//            },
            linkfn: function (e, data, type, row, meta) { //e, data, type, row, meta
              return modul.handleDeleteHandler(e, data, type, row, meta);
            }
          }
        ],

        options: {
          defaultSortKey: "tasktimestamp",
          defaultSortDirection: "asc",
        }
      };
    },
    props: {
      id: String,
    },
    watch: {
      "$store.state.healthCheckHash": function (newData, oldData) {
        const modul = this;
        if (newData !== oldData) {
          modul.state = Object.assign({}, modul.$store.state);
          modul.handleRights();
          this.getElements();
          modul.initIntNavFillError();
        }
      },
      'hasRole': function (newVal, oldVal) {
        const modul = this;
        if (newVal && !oldVal) {
          if (modul.hasRole && modul.hasCompany) {
            modul.init();
          }
        }
      },

      '$route.params': function (newdata, olddata) {
        if (this.$route.params.id) {
          this.id = newdata;
          this.getElements();
//          this.getElement();
        } else {
          this.id = void 0;
        }
      }
    },
    mounted() {
      const modul = this;
      modul.handleRights();
      modul.myTimerFnVar = modul.myTimerFn
      modul.redirectOff = false;
    },
    beforeDestroy() {
      const modul = this;
      modul.myTimerFnVar = function () {
      };
      clearInterval(modul.redirectCounterIntervalObject);
      modul.redirectOff = true;
    },
    methods: {
      handleRights(){
        const modul = this;
        modul.state = Object.assign({}, modul.$store.state);
        if (HelperRole.hasRights(modul.state, [14], [16, 20])) {
          modul.hasRole = true;
        }
        if (modul.state.id_company) {
          modul.hasCompany = true;
        }
        if (modul.hasRole && modul.hasCompany) {
//          modul.init();
        }
      },
      init(){
        const modul = this;
        const actualDt2 = moment();
        actualDt2.subtract('months', 1);
        actualDt2.set('date', 1);
        actualDt2.set('hour', 0);
        actualDt2.set('minute', 0);
        actualDt2.set('second', 0);
        actualDt2.set('millisecond', 0);
        modul.data.dt_from = actualDt2.clone().format('YYYY-MM-DD HH:mm:ss');
        modul.data.dt_to = actualDt2.clone().endOf('month').format('YYYY-MM-DD HH:mm:ss');
        this.getElements();
        modul.initIntNavFillError();
      },
      initIntNavFillError(){
        const modul = this;
        if (modul.$store.state && modul.$store.state.settings) {
          modul.settings = modul.$store.state.settings;
          const hasNavFeatures = HelperRole.hasRights(modul.state, [15], true);
          modul.intNavFillError = (hasNavFeatures && !(modul.$store.state.settings.hasnav === "true" && modul.$store.state.settings.navTechUserName && modul.$store.state.settings.navTechXmlChangeKey && modul.$store.state.settings.navTechXmlSignatureKey)) ? 1 : -1;
        }
      },
      handleDeleteHandler(event, data, type, row, meta){
        const modul = this;
        const fnCb = function () {
          const dt_transfer = moment().format('YYYY-MM-DD');
          const id = row.id;
          const postData = {}
          const alertId = Math.random();
          modul.$eventBus.$emit('globalAlert', {
            id: alertId,
            type: "warning",
            msgPreInner: "",
            msg: "form.in_progress",
            msgPostInner: "",
            delay: 50000
          });
          Api.delTask({id_company: modul.$store.state.id_company, id: id, data: postData}).then(function (res) {
            if (res && res.result) {
              if (Helper.Number(res.data.affected) === 1) {
                modul.getElements();
              }
            }
            modul.$eventBus.$emit('globalAlert', {
              id_delete: alertId,
              type: "success",
              msgPreInner: "",
              msg: "form.succes",
              msgPostInner: "",
              delay: 5000
            });
          }, function (e) {
            modul.$eventBus.$emit('globalAlert', {
              id_delete: alertId,
              type: "danger",
              msgPreInner: "",
              msg: "form.error",
              msgPostInner: "",
              delay: 5000
            });
          });
        }
        modul.$eventBus.$emit('modal', {
          type: "confirm",
          msgTitle: "",
          tmsgTitle: "question",
          msgText: modul.$t("modal.areyousuredelete"),
          tmsgText: "",
          fnCancel: function () {
            console.log('fnCancel')
          },
          fnConfirm: function () {
            console.log('fnConfirm')
            fnCb()
          }
        });
      },
      myTimerFn() {
        const modul = this;
        modul.redirectCounter--;
        if (modul.redirectCounter % 5 === 0) {
          modul.getElements();
        }
        if (modul.redirectCounter === 0) {
          clearInterval(modul.redirectCounterIntervalObject);
          if (modul.redirectOff === false) {
            modul.redirect()
          }
        }
      },
      initCounter() {
        const modul = this;
        // ha fut akkor stop
        if (modul.redirectCounterIntervalObject) {
          clearInterval(modul.redirectCounterIntervalObject);
        }
        modul.myTimerFnVar = modul.myTimerFn;
        modul.redirectCounter = 60;
        modul.redirectCounterIntervalObject = setInterval(modul.myTimerFnVar, 1000);
      },
      cancelCounter() {
        const modul = this;
        clearInterval(modul.redirectCounterIntervalObject);
        modul.redirectCounter = 0;
      },
      redirect() {
        const modul = this;
        modul.$router.push({name: "sbinvoiceinbounds"})
      },
      renderName(data, type, dataRow, meta) {
        const modul = this;
        const dataRet = modul.$t("taskProcessor." + data);
        return dataRet;
      },
      renderTs(data, type, dataRow, meta) {
        const modul = this;
        const dataRet = moment.utc(data).local().format('YYYY-MM-DD HH:mm:ss')
        return dataRet;
      },
      navRefreshPeriodMonth(){

      },
      navRefreshPeriod(){
        const modul = this;
        modul.$validator.validateAll().then((result) => {
          let success = false;
          if (moment.utc(modul.data.dt_from).add(34, "days") > moment.utc(modul.data.dt_to) && moment.utc(modul.data.dt_from) <= moment.utc(modul.data.dt_to)) {
            success = true;
          }
          if (success && result) {
            const req = {};
            req.data = {};
            req.data.dateFrom = modul.data.dt_from;
            req.data.dateTo = modul.data.dt_to;
            req.id_company = modul.state.id_company;

            modul.inprogress = true;
            const alertId = Math.random();
            modul.$eventBus.$emit('globalAlert', {
              id: alertId,
              type: "warning",
              msgPreInner: "",
              msg: "form.in_progress",
              msgPostInner: "",
              delay: 50000
            });

//            modul.AlertInPage.msg = "form.in_progress";
//            modul.AlertInPage.type = "warning";

            Api.navRefreshPeriodInbound(req).then(function (res) {
              if (res && res.result) {
                if (res && res.data.id) {
                  modul.data.id = res.data.id;
                }
//                modul.AlertInPage.msg = "InvoiceInboundNAVRefresh.successMaketask";
//                modul.AlertInPage.type = "success";
                modul.initCounter();
                modul.$eventBus.$emit('globalAlert', {
                  id_delete: alertId,
                  type: "success",
                  msgPreInner: "",
                  msg: "InvoiceInboundNAVRefresh.successMaketask",
                  msgPostInner: "",
                  delay: 5000
                });
//                setTimeout(function (e) {
//                  modul.AlertInPage.msg = "";
//                  modul.getElements();
//                }, Number(modul.AlertInPage.delay));
              } else {
                modul.$eventBus.$emit('globalAlert', {
                  id_delete: alertId,
                  type: "danger",
                  msgPre: "",
                  msg: "InvoiceInboundNAVRefresh.unsuccessMaketask",
                  msgPost: modul.$t("NAV.navErrors." + res.message),
                  delay: 5000
                });

//                modul.AlertInPage.msg = "InvoiceInboundNAVRefresh.unsuccessMaketask";
//                modul.AlertInPage.msgPost = modul.$t("NAV.navErrors." + res.message);
//                modul.AlertInPage.type = "danger";
//                setTimeout(function (e) {
//                  modul.AlertInPage.msg = "";
//                  modul.AlertInPage.msgPost = "";
//                }, Number(modul.AlertInPage.delay));
              }
              modul.inprogress = false;
            }, function (e) {
              modul.$eventBus.$emit('globalAlert', {
                id_delete: alertId,
              });

              /**/
              modul.AlertInPage.msg = "";
              modul.inprogress = false;

            });

          } else {
            modul.$eventBus.$emit('globalAlert', {
//              id_delete: alertId,
              type: "danger",
              msgPre: "",
              msg: "InvoiceInboundNAVRefresh.dataerror",
              msgPost: "",
              delay: 5000
            });
//            modul.AlertInPage.msg = "InvoiceInboundNAVRefresh.dataerror";
//            modul.AlertInPage.type = "danger";
//            setTimeout(function (e) {
//              modul.AlertInPage.msg = "";
//              modul.AlertInPage.msgPost = "";
//            }, Number(modul.AlertInPage.delay));
          }
        });
      },
      getElements(){
        const modul = this;
        const data = {
          taskname: "navprocessorinbound"
        };
        const alertId = Math.random();
        modul.$eventBus.$emit('globalAlert', {
          id: alertId,
          type: "warning",
          msgPreInner: "",
          msg: "form.in_progress",
          msgPostInner: "",
          delay: 50000
        });

//        modul.AlertInPage.msg = "form.in_progress";
//        modul.AlertInPage.type = "warning";
        Api.getTasks({id_company: modul.$store.state.id_company, data: data}).then(function (res) {
          modul.$eventBus.$emit('globalAlert', {
            id_delete: alertId,
          });
          if (res && res.result) {
            modul.dataDt = Array.from(res.data);
          }
//          modul.AlertInPage.msg = "";
        });
      }

    },
    components: {
      LeftMenu,
      HeaderSearch,
      HeaderCompanySelector,
      HeaderNotification,
      HeaderMessages,
      User,
      LngChooser,
      Breadcrumbs,
      AlertInPage,
      InputText,
      MenuToggle,
      TableDatatableJs
    },
  };
</script>








